import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const DeliveryTruck = (props: IconWrapperProps) => {
  return (
    <IconWrapper width="24" height="25" viewBox="0 0 24 24" {...props}>
      <path
        stroke="#282828"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.7 18.3a1.58 1.58 0 1 1-2.23 2.24 1.58 1.58 0 0 1 2.23-2.24M7.7 18.3a1.58 1.58 0 1 1-2.23 2.24A1.58 1.58 0 0 1 7.7 18.3M10 4h4a1 1 0 0 1 1 1v10H2"
      />
      <path
        stroke="#282828"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5 19.42H3a1 1 0 0 1-1-1V13M15 7h4.32a1 1 0 0 1 .93.63l1.6 4.01a2 2 0 0 1 .15.74v5.95a1 1 0 0 1-1 1h-1.83M16 19.42H8.17"
      />
      <path
        stroke="#282828"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22 14h-4v-4h3.2M2 4h5M2 7h3M3 10H2"
      />
    </IconWrapper>
  );
};

export default DeliveryTruck;
